// @ vendors
import Immutable from 'immutable';
// @ constants
import { WIZARD_FIRST_STEP, WIZARD_SECOND_STEP } from 'constants/index';
import { STATUSES } from '../routes/accountCancelView/constants';
const {
    ACCOUNT_CANCEL_MOTIVE_SELECT_CHANGED,
    ACCOUNT_CANCEL_MOTIVE_INPUT_CHANGED,
    ACCOUNT_CANCEL_SET_VISIBLE_STEP,
    ACCOUNT_CANCEL_SET_VALIDATE_STEP,
    ACCOUNT_CANCEL_SET_PRE_LEAVE_MODAL,
    ACCOUNT_CANCEL_SET_PRE_LEAVE_IS_PERSONAL_DATA,
    ACCOUNT_CANCEL_RESET_STATE,
    ACCOUNT_CANCEL_REQUEST,
    ACCOUNT_CANCEL_SUCCESS,
    ACCOUNT_CANCEL_FAIL,
    FETCH_ACCOUNT_INTERVENERS_FAILURE,
} = require('constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    status: STATUSES.IDLE,
    error: '',
    currentStep: WIZARD_FIRST_STEP,
    motiveSelect: "",
    motiveDetail: "",
    showPreLeaveModal: false,
    isPreLeavePersonalData: false,
    steps: [
        {
            valid: true,
        },
        {
            valid: true,
        },
        {
            valid: true,
        }
    ],
});

const validateStep = (previousState) => {
    return previousState.get('currentStep') === WIZARD_FIRST_STEP || previousState.get('currentStep') === WIZARD_SECOND_STEP ? previousState.merge({
        currentStep: previousState.get('currentStep') + 1
    }) : previousState;
}

const setPreLeaveModal = (previousState, show) => {
    return previousState.merge({
        showPreLeaveModal: show,
    });
}

const setIsPreLeavePersonalData = (previousState, isPreLeavePersonalData) => {
    return previousState.merge({
        isPreLeavePersonalData: isPreLeavePersonalData,
    });
}

const createSaveSucessState = previousState => {
    return previousState.merge({
        status: STATUSES.SAVED,
        error: '',
    });
};

const createSaveFailedState = (previousState, error) => {
    return previousState.merge({
        status: STATUSES.ERROR,
        error: error,
    });
};

const createIsSavingState = previousState => {
    return previousState.merge({
        status: STATUSES.SAVING,
        error: '',
    });
};

const createMotiveSelectChange = (previousState, payload) => {
    return previousState.merge({
        motiveSelect: payload,
        motiveDetail: "",
    });
};

const createMotiveInputChange = (previousState, payload) => {
    return previousState.merge({
        motiveDetail: payload,
    });
};

const setVisibleStep = (previousState, step) => {
    return previousState.merge({
        currentStep: step,
    })
}

const setResetState = (previousState) => {
    return previousState.merge(INITIAL_STATE);
}


function accountCancel(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACCOUNT_CANCEL_MOTIVE_SELECT_CHANGED:
            return createMotiveSelectChange(state, action.payload);
        case ACCOUNT_CANCEL_MOTIVE_INPUT_CHANGED:
            return createMotiveInputChange(state, action.payload);
        case ACCOUNT_CANCEL_SET_VISIBLE_STEP:
            return setVisibleStep(state, action.payload.step);
        case ACCOUNT_CANCEL_SET_VALIDATE_STEP:
            return validateStep(state);
        case ACCOUNT_CANCEL_SET_PRE_LEAVE_MODAL:
            return setPreLeaveModal(state, action.payload.show);
        case ACCOUNT_CANCEL_SET_PRE_LEAVE_IS_PERSONAL_DATA:
            return setIsPreLeavePersonalData(state, action.payload.isPreLeavePersonalData);
        case ACCOUNT_CANCEL_RESET_STATE:
            return setResetState(state);
        case ACCOUNT_CANCEL_REQUEST:
            return createIsSavingState(state);
        case ACCOUNT_CANCEL_SUCCESS:
            return createSaveSucessState(state);
        case ACCOUNT_CANCEL_FAIL:
        case FETCH_ACCOUNT_INTERVENERS_FAILURE:
            return createSaveFailedState(state, action.payload.error);
        default:
            return state;
    }
}

module.exports = accountCancel;
